import { getApolloContext } from '@apollo/client'
import { useAuth0 } from '@auth0/auth0-react'
import { Tracker, useSalescoreAuth } from '@salescore/client-base'
import { createFileRoute, useRouter } from '@tanstack/react-router'
import { message } from 'antd'
import { t } from 'i18next'
import { useContext, useEffect } from 'react'

const Page = (): null => {
  const { clearToken } = useSalescoreAuth()
  const { logout } = useAuth0()
  const { client } = useContext(getApolloContext())
  const router = useRouter()

  useEffect(() => {
    const f = async (): Promise<void> => {
      clearToken()
      await logout({
        logoutParams: { returnTo: `${process.env.FRONT_URL}${router.buildLocation({ to: '/sign_in' }).href}` },
      })
      void message.info(t(`ログアウトしました`))
      await client?.resetStore() // 異なるidentityでログインするケースのためにリセットしておく
      Tracker.shared().setToken(undefined)
    }
    void f()
  }, [clearToken, client, logout, router])

  return null
}

export const Route = createFileRoute('/sign_out')({
  component: Page,
})
